module.exports = __webpack_public_path__ + "static/img/bb3.6782a36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bb3.png
// module id = w8Bi
// module chunks = 2